import EntryActionTypes from '../../constants/EntryActionTypes';

export const createBrand = (data) => ({
  type: EntryActionTypes.BRAND_CREATE,
  payload: {
    data,
  },
});

export const updateCurrentBrand = (data) => ({
  type: EntryActionTypes.CURRENT_BRAND_UPDATE,
  payload: {
    data,
  },
});

export const deleteCurrentBrand = () => ({
  type: EntryActionTypes.CURRENT_BRAND_DELETE,
  payload: {},
});
